import ApplicationController from './application_controller';

// Live-updates the read-only "Duration (actual)" field on the visit-note custom form as the user
// edits the session start/end times. Duration (actual) is the delta between the session start and
// end times (in minutes). The server stays authoritative on save — and falls back to the billed
// duration when either time is blank (see VisitNote#actual_duration_minutes) — so this is only an
// at-a-glance live preview: it recomputes when BOTH times are present and a positive window exists,
// and otherwise restores the server-rendered value rather than clobbering the billed fallback.
//
// The session start/end inputs live in sibling smart-control partials, so we locate them by name
// (…[start_date] / …[end_date]) at the document level — there is only one visit-note form per page.
export default class extends ApplicationController {
  static targets = ['output'];

  connect() {
    if (!this.hasOutputTarget) return;
    this.originalValue = this.outputTarget.value;
    this.startInput = document.querySelector('input[name$="[start_date]"]');
    this.endInput = document.querySelector('input[name$="[end_date]"]');
    if (!this.startInput || !this.endInput) return;

    this.recompute = this.recompute.bind(this);
    ['input', 'change'].forEach((evt) => {
      this.startInput.addEventListener(evt, this.recompute);
      this.endInput.addEventListener(evt, this.recompute);
    });
  }

  disconnect() {
    if (!this.startInput || !this.endInput) return;
    ['input', 'change'].forEach((evt) => {
      this.startInput.removeEventListener(evt, this.recompute);
      this.endInput.removeEventListener(evt, this.recompute);
    });
  }

  recompute() {
    const start = this.startInput.value;
    const end = this.endInput.value;
    if (start && end) {
      const minutes = Math.round((new Date(end) - new Date(start)) / 60000);
      if (!Number.isNaN(minutes) && minutes > 0) {
        this.outputTarget.value = `${minutes} minutes`;
        return;
      }
    }
    // Missing a time (or an invalid/negative window) — can't compute a delta, so fall back to the
    // server-rendered value (which may be the billed-duration default).
    this.outputTarget.value = this.originalValue;
  }
}
